/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:01:48
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginPopover from 'bee-popover';
import { getSysFieldid } from '@platform/api';
import './index.less'
require('bee-popover/build/Popover.css');

export default class Popover extends Component {
	render() {
		let { fieldid, className, ...others } = this.props;
		return <OriginPopover className={`${className + ' nc-popover'}`} {...others} fieldid={getSysFieldid(fieldid)} />;
	}
}
